import React, {Component} from 'react'

import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button'

import AddItemIcon from '@material-ui/icons/Add'
import EditItemAmountIcon from '@material-ui/icons/Ballot'
import RemoveItemIcon from '@material-ui/icons/DeleteForever'
import CompleteShowIcon from '@material-ui/icons/CheckCircle'
import CommentIcon from '@material-ui/icons/Comment'
import SaveIcon from '@material-ui/icons/SaveAlt'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';

import PaperBlock from "../../../ui/PaperBlock"

import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'

/**
 * 	<ControlPanel
 * 		selected
 * 		show
 * 		readyToComplete
 * 		onAttachItemClick = {}
 * 		onAttachTemplateClick = {}
 * 		onEditItemAmountClick = {item}
 * 		onRemoveItemClick = {item}
 * 		onCompleteShowClick ={}
 * 		onCommentClick = {show}
 * 		onReportClick = {show}
 * 		onCartClick = {show}
 * 	/>
 */

class ControlPanel extends Component {

	state = {
		anchorEl: null,
	}

	render() {

		return <PaperBlock style = {{display: "flex", flexWrap: "wrap"}}>

			<Tooltip title = "Добавить предмет"><div>

				<Button
					aria-owns = {this.state.anchorEl ? 'add-item-menu' : undefined}
					aria-haspopup = "true"
					disabled = {this.props.show.completed === "1"}
					onClick = {e => {
						e.stopPropagation()
						this.setState({
							anchorEl: e.currentTarget,
						})
					}}
				>
					<AddItemIcon />
				</Button>

			</div></Tooltip>

			<Menu
				id = 'add-item-menu'
				anchorEl = {this.state.anchorEl}
				open = {Boolean(this.state.anchorEl)}
				onClose = {e => {
					this.setState({
						anchorEl: null,
					})
				}}
			>

				<MenuItem onClick = {e => {
					e.stopPropagation()
					this.setState({
						anchorEl: null,
					}, () => {
						if (typeof this.props.onAttachItemClick === "function") {
							this.props.onAttachItemClick()
						}
					})
				}}>Добавить предмет</MenuItem>

				<MenuItem onClick = {e => {
					e.stopPropagation()
					this.setState({
						anchorEl: null,
					}, () => {
						if (typeof this.props.onAttachTemplateClick === "function") {
							this.props.onAttachTemplateClick()
						}
					})
				}}>Добавить из шаблона</MenuItem>

			</Menu>

			<Tooltip title = {this.props.show ? (this.props.show.completed === "1" ? "Отменить завершение" : "Завершить шоу") : ""}><div>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCompleteShowClick === "function") {
							this.props.onCompleteShowClick()
						}
					}}
				>
					<CompleteShowIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Изменить кол-во"><div>
				<Button
					disabled = {!this.props.selected || (this.props.show.completed === "1")}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onEditItemAmountClick === "function") {
							this.props.onEditItemAmountClick(this.props.selected)
						}
					}}
				>
					<EditItemAmountIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Удалить предмет"><div>
				<Button
					disabled = {!this.props.selected || (this.props.show.completed === "1")}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onRemoveItemClick === "function") {
							this.props.onRemoveItemClick(this.props.selected)
						}
					}}
				>
					<RemoveItemIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Комментарий"><div>
				<Button
					disabled = {this.props.show.completed === "1"}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCommentClick === "function") {
							this.props.onCommentClick(this.props.show)
						}
					}}
				>
					<CommentIcon />
				</Button>
			</div></Tooltip>

			<Tooltip title = "Сохранить отчет"><div>
				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onReportClick === "function") {
							this.props.onReportClick(this.props.show)
						}
					}}
				>
					<SaveIcon />
				</Button>
			</div></Tooltip>

			{/* <Tooltip title = "Создать закупку"><div>
				<Button
					onClick={e =>{
						e.stopPropagation()
						if (typeof this.props.onCartClick === "function") {
							this.props.onCartClick(this.props.show)
						}
					}}
				>
					<ShoppingCartIcon/>
				</Button>
			</div></Tooltip> */}

		</PaperBlock>

	}

}

export default ControlPanel
